(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kodo-universal-subcategory"] && !Shopify.designMode) return;
  try {
    
  const mobileBreakpoint = window.matchMedia('(max-width: 749px)');
  const categoryDisclosures = document.querySelectorAll('.kodo-category__disclosure');

  const syncCategoryDisclosures = () => {
    categoryDisclosures.forEach((disclosure) => {
      if (mobileBreakpoint.matches) {
        disclosure.setAttribute('name', disclosure.dataset.accordionName);
        disclosure.open = false;
      } else {
        disclosure.removeAttribute('name');
        disclosure.open = true;
      }
    });
  };

  syncCategoryDisclosures();
  mobileBreakpoint.addEventListener('change', syncCategoryDisclosures);

  categoryDisclosures.forEach((disclosure) => {
    disclosure.addEventListener('toggle', () => {
      if (!mobileBreakpoint.matches && !disclosure.open) {
        disclosure.open = true;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
